import config from '#/config';

export const TESTNET_SANDBOX_COMPETITION_ENABLED = false;
// window.location.search === '?TESTNET_DISABLE_COMPETITION' ||
// config.env !== 'sandbox'
//   ? false
//   : true;

/** Sandbox */
export const TESTNET_SANDBOX_WELCOME_ENABLED =
  window.location.search === '?TESTNET_DISABLE_COMPETITION' ||
  config.env !== 'sandbox'
    ? false
    : true;

export const TESTNET_SANDBOX_REWARD_IDEX = 0;
